<script>
export default {
  props: {
    item: Object,
  },
  data: () => ({
    showClass:'',
    toggleValue:false
  }),
  computed: {
  },
  // mounted() {
  //   console.log(this.item);
  // },
  methods: {
    openClient(value) {
      const url = '/tourclient/dictionary/#/client/edit/'+value
      window.open(url,'_blank')
    },
    openAgreement(value) {
      const url = '/tourclient/admin/orders/info.html?code=' + value
      window.open(url, '_blank');
    },
    toggle() {
      this.toggleValue = !this.toggleValue
      this.showClass = this.toggleValue ? "hide" : "";
    }
  },
};
</script>
<template>
  <div class="agreement-body">
    <el-row class="agreement-item">
      <el-col :span="4" ><span  @click="openAgreement(item.code)">{{item.code}}</span>
        <div  style="display: inline">
          <BtnIcon
            class="btn-transparent"
            :class="showClass"
            slot="btn"
            @click="toggle"
            icon="el-icon-arrow-down"
          /></div></el-col>
      <el-col :span="1">

      </el-col>
    </el-row>
    <div class="client-list"  :class="showClass">
      <div class="client-item" v-for="(client, j) in item.clients" :key="j" @click="openClient(client.id)">
        {{client.fullName}}
      </div>
    </div>
  </div>
</template>
<style lang="scss">
#item_card_dialog_board {
  .agreement-body {
    margin-top: 5px;
  }

  .agreement-item {
    font-size: 18px;
    font-width: 500;
    color: #409eff;
    cursor: pointer;
    .btn-transparent {
      border-radius: 0%;
      font-size: 16px;
      height: 16px;
      background: transparent;
      box-shadow: none;
      border-color: transparent;
      margin-top: -3px;
      margin-left: -8px;
      color: #409eff;
      &.hide {
        transform: rotate(180deg);
      }
    }
  }

  .client-list{
    margin-left: 10px;
    display: block;
    &.hide{
      display: none;
    }
    .client-item{
      cursor: pointer;
      color: #8ac15d;
    }
  }
}
</style>
